/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./timeline-slider.component.styl.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./timeline-slider.component";
import * as i3 from "../timeline.store";
var styles_TimelineSliderComponent = [i0.styles];
var RenderType_TimelineSliderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TimelineSliderComponent, data: {} });
export { RenderType_TimelineSliderComponent as RenderType_TimelineSliderComponent };
export function View_TimelineSliderComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { element: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["element", 1]], null, 3, "div", [["class", "timeline-slider"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n  "])), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_TimelineSliderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-timeline-slider", [], null, null, null, View_TimelineSliderComponent_0, RenderType_TimelineSliderComponent)), i1.ɵdid(1, 245760, null, 0, i2.TimelineSliderComponent, [i3.TimelineStore], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TimelineSliderComponentNgFactory = i1.ɵccf("app-timeline-slider", i2.TimelineSliderComponent, View_TimelineSliderComponent_Host_0, {}, {}, ["*"]);
export { TimelineSliderComponentNgFactory as TimelineSliderComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-slider/timeline-slider.component.ngfactory.js.pre-build-optimizer.js